import { Button } from "@minervaproject/fds";

import { useUserIdsWithCapability } from "hooks/capabilities";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { USER_PICKER_PROPERTIES, useUsersProperties } from "hooks/use_user_properties";
import { CapabilityType } from "shared/types";
import { classroomSelectors, localSelectors } from "store";
import { pickUsersAndSetParticipantBarAndStage } from "utils/classroom";

function ShuffleButton() {
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const isInPerson = useAppSelector(classroomSelectors.selectIsInPersonClass());
  const activeBreakoutSessionId = useAppSelector(
    classroomSelectors.selectActiveBreakoutSessionId(),
  );
  const maxSubscribedStreams = useAppSelector(classroomSelectors.selectMaxSubscribedStreams());
  const users = Object.values(useUsersProperties(USER_PICKER_PROPERTIES));
  const isVisibleInClassUserIds = useUserIdsWithCapability(CapabilityType.IS_VISIBLE_IN_CLASS);
  const presentVisibleUsers = users.filter(
    (user) => user.is_present && isVisibleInClassUserIds.includes(user.id),
  );
  const { panes } = useAppSelector(classroomSelectors.selectStage());
  const isAlwaysSubscribedToUserIds = useUserIdsWithCapability(
    CapabilityType.IS_ALWAYS_SUBSCRIBED_TO,
  );
  const canParticipateInClassUserIds = useUserIdsWithCapability(
    CapabilityType.CAN_PARTICIPATE_IN_CLASS,
  );
  const participantBarUserIds = useAppSelector(classroomSelectors.selectParticipantBarUserIds());

  const handleShuffle = () => {
    pickUsersAndSetParticipantBarAndStage(
      dispatch,
      maxSubscribedStreams,
      currentUserId,
      presentVisibleUsers,
      isAlwaysSubscribedToUserIds,
      canParticipateInClassUserIds,
      participantBarUserIds,
      panes,
    );
  };

  if (isInPerson || activeBreakoutSessionId) return null;

  return (
    <div className="flex-none mt3 mx2">
      <Button kind="classroom-primary" onClick={handleShuffle}>
        {presentVisibleUsers.length <= maxSubscribedStreams
          ? "Shuffle Students On Stage"
          : "Shuffle Students"}
      </Button>
    </div>
  );
}

export { ShuffleButton };
